import { useMutation } from '@tanstack/react-query';

/**
 * This function deletes an image from the blob using the blob endpoint
 * @param blobEndpoint blob endpoint of the image to be deleted
 */
export const deleteImageFromBlob = async (blobEndpoint: string) => {
  try {
    const response = await fetch(blobEndpoint, {
      method: 'DELETE',
      headers: {
        'x-ms-blob-type': 'BlockBlob',
      },
    });
    if (!response.ok) {
      throw new Error('Failed to delete image from blob');
    }
  } catch (error) {
    throw new Error((error as Error).message);
  }
};

export const useDeleteImage = () =>
  useMutation({
    mutationFn: async (blobEndpoint: string) =>
      await deleteImageFromBlob(blobEndpoint),
    onError: (error) => {
      throw new Error((error as Error).message);
    },
  });
